//@flow
import {
  createCrmSegmentApi,
  createCrmSegmentTaskApi,
  listCrmSegmentsApi,
  getCrmSegmentByIdApi,
  getCrmSegmentTaskApi,
  editCrmSegmentApi,
  endpoints,
} from './api';
import {buildRoute} from '../../http';

import type {CrmSegmentFilter} from '../../entities/crm/segment';
import type {PaginationRequest, PaginationResponse} from '../../entities';

export type CreateCrmSegmentType = 'MANUAL' | 'AUTOMATIC';
type CreateCrmSegmentRequest = {
  enabled: true,
  name: string,
  segmentType: CreateCrmSegmentType,
  filters?: CrmSegmentFilter,
};

type EditCrmSegmentRequest = {
  name?: string,
  enabled?: boolean,
};

type CrmSegmentCreateResponse = {
  id: string,
  storeId: string,
  enabled: boolean,
  name: string,
  segmentType: CreateCrmSegmentType,
  filters: any,
  lastSyncAt: null,
  createdAt: string,
  updatedAt: string,
  type: 'segment',
};

export function createCrmSegmentService(
  request: CreateCrmSegmentRequest
): Promise<CrmSegmentCreateResponse> {
  return createCrmSegmentApi(request).toPromise();
}

type CreateCrmSegmentTaskRequest = {
  segmentId: string,
  fileId: string,
  taskType: 'UPLOAD_CONTACTS',
};

export function createCrmSegmentTaskService(
  request: CreateCrmSegmentTaskRequest
) {
  return createCrmSegmentTaskApi(request).toPromise();
}

export type CrmSegmentListItem = {
  id: string,
  storeId: string,
  enabled: boolean,
  name?: string,
  segmentType: CreateCrmSegmentType,
  filters?: any,
  lastSyncAt?: string,
  createdAt: string,
  updatedAt: string,
  type: 'segment',
};

export function listCrmSegmentsService(
  params: PaginationRequest
): Promise<PaginationResponse<CrmSegmentListItem>> {
  return listCrmSegmentsApi(params).toPromise();
}

export type CrmSegment = {
  id: string,
  storeId: string,
  enabled: boolean,
  name?: string,
  segmentType: CreateCrmSegmentType,
  filters?: any,
  lastSyncAt?: string,
  createdAt: string,
  updatedAt: string,
  type: 'segment',
};

export function getCrmSegmentByIdService(
  segmentId: string
): Promise<CrmSegment> {
  const route = buildRoute(endpoints.GET_CRM_SEGMENT_BY_ID, [segmentId]);
  return getCrmSegmentByIdApi(undefined, {route}).toPromise();
}

export type CrmSegmentTaskErrorResult = {
  errorName: string,
  detail: string,
};

export type CrmSegmentTaskResult = {
  scope: string,
  index: number,
  message: string,
  field?: string,
  type?: 'not_found' | 'type' | 'missing',
};
export type CrmSegmentTask = {
  id: string,
  state: 'PENDING' | 'DONE' | 'FAILED' | 'empty',
  segmentTaskType: 'UPLOAD_CONTACTS',
  type: 'segment-task',
  result: CrmSegmentTaskResult[] | CrmSegmentTaskErrorResult,
};

export function getCrmSegmentTaskService(
  segmentId: string
): Promise<CrmSegmentTask[]> {
  const route = buildRoute(endpoints.GET_CRM_SEGMENT_TASK, [segmentId]);
  return getCrmSegmentTaskApi(undefined, {route}).toPromise();
}

export function editCrmSegmentService(
  segmentId: string,
  request: EditCrmSegmentRequest
): Promise<CrmSegmentCreateResponse> {
  const route = buildRoute(endpoints.EDIT_CRM_SEGMENT, [segmentId]);
  return editCrmSegmentApi(request, {route}).toPromise();
}
